'use client';

import type { ReactNode } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export interface StatCardProps {
  icon?: ReactNode;
  value: string | number;
  label: string;
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'warning';
}

export function StatCard({ icon, value, label, color = 'primary' }: StatCardProps) {
  return (
    <Card sx={{ minWidth: 180 }} elevation={0}>
      <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {icon && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 48,
              height: 48,
              borderRadius: 2,
              bgcolor: `var(--color-${color}-container)`,
              color: `var(--color-on-${color}-container)`,
            }}
          >
            {icon}
          </Box>
        )}
        <Box>
          <Typography variant="h5" component="p" sx={{ fontWeight: 600 }}>
            {value}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {label}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}

export default StatCard;
